import {useState, useContext, useEffect} from "react"
import {useNavigate, useLocation} from "react-router-dom"
import {Form, Field} from "react-final-form"
import {WrapperContainer, Radio, AlertDialog, Button} from "ui"
import {
  LOCATION_QUESTION,
  PETSTORE_LOCATION_ALERT,
  PETSTORE_LOCATION_ITEMS,
  BLOCKED_HOME_IMPROVEMENT_STORE,
} from "../../../../constants/accounts/veterinary"
import {RoutePaths, FormButton} from "../../../../constants"
import {nacMachineContext} from "../../../../context"
import {NACEvents, NACStates} from "../../../../machine/nac-machine.types"

const StoreLocation = () => {
  const [open, setOpen] = useState(false)

  const navigate = useNavigate()
  const location = useLocation()
  const {state, send} = useContext(nacMachineContext) || {}

  const renderAlertBox = () => {
    return (
      <AlertDialog
        open={open}
        setOpen={setOpen}
        title={PETSTORE_LOCATION_ALERT.title}
        description={PETSTORE_LOCATION_ALERT.description}
        handleConfirm={() => window.open(PETSTORE_LOCATION_ALERT.contactURL, "_blank")}
        labelConfirm="Contact Us"
      />
    )
  }

  const onSubmit = (values: {homeImprovementStore: string}) => {
    if (BLOCKED_HOME_IMPROVEMENT_STORE.includes(parseInt(values.homeImprovementStore))) {
      setOpen(true)
    } else {
      send(NACEvents.NEXT, {data: values})
      navigate(RoutePaths.SELECT_TRANSACTION_TYPE)
    }
  }

  useEffect(() => {
    if (state?.value !== NACStates.validateHomeImprovementStore) {
      send(NACEvents.INIT, {data: {route: location.pathname}})
    }
  }, [])
  return (
    <div className="flex justify-center">
      <div className="w-full sm:w-[520px]">
        <WrapperContainer>
          <p className="mb-3 font-bold text-gray-700">{LOCATION_QUESTION}</p>

          <Form
            onSubmit={onSubmit}
            initialValues={{homeImprovementStore: state.context.validatePet?.homeImprovementStore}}
            render={({handleSubmit, invalid}) => (
              <form onSubmit={handleSubmit}>
                <div className=" flex flex-col gap-2">
                  {PETSTORE_LOCATION_ITEMS.map(item => {
                    return (
                      <Field
                        key={item.id}
                        name={item.name}
                        component={Radio}
                        type="radio"
                        value={`${item.value}`}
                        label={item.label}
                        validate={value => (value ? undefined : "Required")}
                      />
                    )
                  })}
                </div>
                <div className="mt-10 flex justify-end gap-8">
                  <Button
                    variant="text"
                    onClick={() => {
                      send(NACEvents.BACK)
                      navigate(RoutePaths.ACCOUNT_PET_ALLOWED)
                    }}
                  >
                    {FormButton.BACK}
                  </Button>
                  <Button
                    disabled={invalid}
                    variant="primary"
                    mode="filled"
                    type="submit"
                  >
                    {FormButton.CONTINUE}
                  </Button>
                </div>
              </form>
            )}
          />
          {renderAlertBox()}
        </WrapperContainer>
      </div>
    </div>
  )
}

export default StoreLocation
